import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import type { ProgressBarProps } from './types'

const bem = new BEMHelper('ProgressBar')

/*
Progress value should be a number between 0 and 1 and represents
the progress within an interval
*/
function ProgressBar(props: ProgressBarProps) {
    const { className, title, intervalMinLabel, intervalMaxLabel, value = 0, colorScheme = 'dark' } = props

    return (
        <div className={bem(null, colorScheme, className)}>
            <label htmlFor="progressBar" className={bem('title')}>
                {title}
            </label>
            {intervalMinLabel && intervalMaxLabel ? (
                <p className={bem('intervalLabels')}>
                    <span>{intervalMinLabel}</span>
                    <span>{intervalMaxLabel}</span>
                </p>
            ) : null}
            <progress id="progressBar" className={bem('progressBar', colorScheme)} value={value} max={1} />
        </div>
    )
}

export default ProgressBar
